import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentUtilService } from '../../services';
import { UtilService, EventsService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss']
})
export class RewardsComponent implements OnInit {

  @Input() rewards;
  @Input() currency;
  @Input() campaignId;
  constructor(
    private router: Router,
    private paymentUtilService: PaymentUtilService,
    public utilService: UtilService,
    public eventsService: EventsService,
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
  }

  /**Set the reawrd amount for donation */
  setAmount(reward, other?) {
    if (other) {
      const payload = {
        amount_from: ''
      };
      this.trackingEvents(reward);
      this.paymentUtilService.selectedReward.next(payload);
      this.router.navigate([], {
        queryParams: { payment: 'form' },
        queryParamsHandling: 'merge'
      });
    } else {
      if (reward.status) {
        this.paymentUtilService.selectedReward.next(reward);
        this.router.navigate([], {
          queryParams: { payment: 'form' },
          queryParamsHandling: 'merge'
        });
      }
    }
  }

  /**No push for other reward selection */
  trackingEvents(reward) {
    const claverTap = {
      'Step': 0,
      'id': this.campaignId,
      'Amount': reward.amount,
      'Reward': reward.id,
      'Type_AB': 'typeAB',
      'Page Name': this.variablesService.campaignType || '',
      'iso_currency': this.currency,
      'Recurring': reward.recurring ? true : false
    };

    if (this.variablesService.fundraiser) {
      claverTap['Custom Tag'] = this.variablesService.fundraiser.custom_tag;
    }

    this.eventsService.claverTapPush('New Contribution', claverTap);
  }

}
